import { TaskT } from 'ui-io/task-io/task-t'

import booleanExtractors, { BooleanKey } from './boolean-extractors'
import numberExtractors, { NumberKey } from './number-extractors'
import dateExtractors, { DateKey } from './date-extractors'
import stringExtractors, { StringKey } from './string-extractors'

export type UndefinedKey = 'unsortable'

export const undefinedExtractors = {
  unsortable: () => undefined,
}

export type TaskValueKey =
  | NumberKey
  | BooleanKey
  | DateKey
  | StringKey
  | UndefinedKey
export type TaskValueExtractor = (
  task: TaskT,
) => null | undefined | boolean | number | Date | string
export const valueExtractors: Record<TaskValueKey, TaskValueExtractor> = {
  ...booleanExtractors,
  ...numberExtractors,
  ...dateExtractors,
  ...stringExtractors,
  ...undefinedExtractors,
}
